import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Button } from '../components/ui/button';
import { BillRow, Page, useReport } from './api';
import { BillRows, Empty, LoadState, Pagination } from './shared';
export default function Bills({
  refresh,
  retry,
  onBill,
  onUser,
}: {
  refresh: number;
  retry: () => void;
  onBill: (id: string) => void;
  onUser: (id: string) => void;
}) {
  const [q, setQ] = useState(''),
    [search, setSearch] = useState(''),
    [status, setStatus] = useState('all'),
    [includeTestData, setIncludeTestData] = useState(false),
    [offset, setOffset] = useState(0);
  const { data, loading, error } = useReport<Page<BillRow>>(
    '/bills',
    {
      q: search,
      status,
      includeTestData,
      offset,
    },
    refresh
  );
  return (
    <section className="admin-panel">
      <div className="admin-section-heading">
        <div>
          <h2>Every bill, in one place</h2>
          <p>All dates. Search by title, creator, or bill ID.</p>
        </div>
        <label className="admin-check-label">
          <input
            type="checkbox"
            checked={includeTestData}
            onChange={(e) => {
              setIncludeTestData(e.target.checked);
              setOffset(0);
            }}
          />
          Include test bills
        </label>
      </div>
      <div className="admin-filters">
        <form
          className="admin-search"
          onSubmit={(e) => {
            e.preventDefault();
            setSearch(q);
            setOffset(0);
          }}
        >
          <Search size={18} />
          <input
            aria-label="Search bills"
            placeholder="Search bills…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <Button variant="ghost" type="submit">
            Search
          </Button>
        </form>
        <select
          aria-label="Bill status"
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            setOffset(0);
          }}
        >
          <option value="all">All statuses</option>
          <option value="editing">Editing</option>
          <option value="finished">Finished</option>
          <option value="partial">Partially repaid</option>
          <option value="settled">Settled</option>
        </select>
      </div>
      <LoadState loading={loading} error={error} retry={retry} />
      {data && (
        <>
          {data.items.length ? (
            <BillRows bills={data.items} onBill={onBill} onUser={onUser} />
          ) : (
            <Empty title="No matching bills" detail="Try another title or clear your filters." />
          )}
          <Pagination
            total={data.total}
            offset={offset}
            next={data.nextOffset}
            onPage={setOffset}
          />
        </>
      )}
    </section>
  );
}
